module.exports = __webpack_public_path__ + "static/img/back.155119f1.png";